import * as React from 'react';
import { FC, useState } from 'react';
import Provider from './Provider';
import { CasinoFiltersProps, ProviderInfo } from './types';

const ProviderFilter: FC<{
  value: string;
  onChange: (v: string) => void;
  providerInfos: ProviderInfo[];
  locales: CasinoFiltersProps['locales'];
}> = ({ value, onChange, providerInfos, locales }) => {
  const [classname, setClassname] = useState('inactive');

  const showProviders = () => {
    setClassname((prev) => (prev === 'active' ? 'inactive' : 'active'));
    document.dispatchEvent(new CustomEvent('scroll'));
  };

  const onClickDropdown = () => {
    showProviders();
  };

  const onClickProvider = (v: string) => {
    onChange(v);
    showProviders();
  };

  const onClickClear = () => {
    onChange('');
    setClassname('inactive');
  };

  return (
    <div className="providers">
      <div className="providers_title" id="casino-filters__provider">
        <h4>{locales.vendors}</h4>
      </div>
      <div className="providers_buttons">
        <div
          className={`providers_button ${value !== '' ? 'chosen' : ''} ${classname}`}
          onClick={onClickDropdown}
          aria-labelledby="casino-filters__provider"
        >
          <span>{`${value === '' ? `${locales.all_vendors} (${providerInfos.length})` : value}`}</span>
        </div>
        <div
          className={`providers_clean ${value !== '' ? 'chosen' : ''}`}
          onClick={onClickClear}
          title="clear provider"
        />
      </div>
      <div className={`icon-bar three-up providers-bar providers_list ${classname}`} data-testid="providers-list">
        {providerInfos.map((providerInfo) => (
          <Provider
            key={providerInfo.provider}
            providerInfo={providerInfo}
            onClick={onClickProvider}
            active={value === providerInfo.provider}
            locales={locales}
          />
        ))}
      </div>
    </div>
  );
};

export default ProviderFilter;
